import config from "../config/config";

// util: 緯度経度 -> WebMercator 0..1 と中心固定で全点が入るズーム推定
export const lonToX = lon => (lon + 180) / 360;

export const latToY = lat => {
  const sin = Math.sin((lat * Math.PI) / 180);
  return 0.5 - Math.log((1 + sin) / (1 - sin)) / (4 * Math.PI);
};

// 中心を固定して全点が入るズームを推定する関数
export function calculateZoomKeepCenter(
  items,
  center,
  mapWidth,
  mapHeight,
  padding = config.map.zoomAdjust.padding,
  tileSize = config.map.tileSize,
  minZoom = config.map.zoomAdjust.adjustMinZoom,
  maxZoom = config.map.zoomAdjust.adjustMaxZoom
) {
  if (!items || items.length === 0) {
    return Math.min(Math.max(12, minZoom), maxZoom);
  }
  // 中心を WebMercator の正規座標に変換
  const cx = lonToX(center.lng);
  const cy = latToY(center.lat);

  // 中心からの最大偏差（0..1）を求める
  let maxDx = 0, maxDy = 0;
  items.forEach(it => {
    if (it.lon == null || it.lat == null) {
      return;
    }
    const x = lonToX(it.lon);
    const y = latToY(it.lat);
    maxDx = Math.max(maxDx, Math.abs(x - cx));
    maxDy = Math.max(maxDy, Math.abs(y - cy));
  });

  // 範囲分数 = 中心からの最大偏差の *2（両端を考慮）
  const lonFraction = Math.max(1e-9, maxDx * 2);
  const latFraction = Math.max(1e-9, maxDy * 2);

  // 有効な描画領域（paddingを引いたピクセル幅）
  const effectiveWidth = Math.max(1, mapWidth - padding * 2);
  const effectiveHeight = Math.max(1, mapHeight - padding * 2);

  const zoomX = Math.log2(effectiveWidth / (tileSize * lonFraction));
  const zoomY = Math.log2(effectiveHeight / (tileSize * latFraction));
  const zoom = Math.min(zoomX, zoomY);

  // 計算したズームを整数にして、minZoom〜maxZoomの範囲内に収めて返す
  return Math.max(minZoom, Math.min(Math.floor(zoom), maxZoom));
};
